import React from "react";
import "./Study_abroad_Banner.css";

function Study_abroad_Banner({
  heading_Text,
  text_normal_1,
  textbold_1,
  text_normal_2,
  text_normal_3,
  textbold_2,
}) {
  return (
    <section className="Study_abroad_Banner">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-md-9">
            <div className="text_holder">
              <h4>{heading_Text}</h4>
              <p>
                {text_normal_1}
                <span>{textbold_1}</span> {text_normal_2}
              </p>
              <p>
                {text_normal_3} <span>{textbold_2}</span>
              </p>
             
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Study_abroad_Banner;
